module.exports = __webpack_public_path__ + "static/media/align-justify.0a79c278.svg";